<script setup lang="ts">

import ConfigurationSectionRow from "@/pages/Settings/AppConfigurationPage/components/ConfigurationSectionRow.vue";
import FontUploaderForm from "@/pages/Settings/AppConfigurationPage/components/FontUploaderForm.vue";
</script>

<template>
  <v-card flat color="grey-lighten-4">
    <v-card-title>
      Fonts
    </v-card-title>
    <v-divider class="my-2"/>
    <v-card-text>
      <configuration-section-row>
        <template #name>
          Variable Font
        </template>
        <template #comment>
          <b>File type: </b> OTF, TFF, WOFF <br/>
        </template>
        <font-uploader-form configuration-key="variable" />
      </configuration-section-row>
      <configuration-section-row>
        <template #name>
          Regular Font
        </template>
        <template #comment>
          <b>File type: </b> OTF, TFF, WOFF <br/>
        </template>
        <font-uploader-form configuration-key="regular" />
      </configuration-section-row>
      <configuration-section-row>
        <template #name>
          Light Font
        </template>
        <template #comment>
          <b>File type: </b> OTF, TFF, WOFF <br/>
        </template>
        <font-uploader-form configuration-key="light" />
      </configuration-section-row>
      <configuration-section-row>
        <template #name>
          Medium Font
        </template>
        <template #comment>
          <b>File type: </b> OTF, TFF, WOFF <br/>
        </template>
        <font-uploader-form configuration-key="medium" />
      </configuration-section-row>
      <configuration-section-row>
        <template #name>
          Bold Font
        </template>
        <template #comment>
          <b>File type: </b> OTF, TFF, WOFF <br/>
        </template>
        <font-uploader-form configuration-key="bold" />
      </configuration-section-row>
    </v-card-text>
  </v-card>
</template>

<style scoped>

</style>
